var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont_wrap"},[_c('grid-component',{attrs:{"type":"合同管理系统"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }